import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { baseUrl,} from './config';
import Cookies from 'js-cookie';

export const CompanyList = createAsyncThunk(
  'directory/CompanyList',
  async () => {
    const url = baseUrl + 'CompanyList';
    const token = Cookies.get("token");
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === "success") {
        return response.data;
      } else {
        return Promise.reject(response.data);
      }
    } catch (err) {
      return Promise.reject(err);
    }
  }
);

export const MemberList = createAsyncThunk(
  'directory/MemberList',
  async (data) => {
   
    const url = baseUrl + 'MemberList';
    const token = Cookies.get("token");
    try {
      const response = (await axios.post(url,data,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })).data
      if (response.status === "success") {
       
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    } catch (err) {
      return Promise.reject(err);
    }
  }
);

export const RequestWithdrowal = createAsyncThunk(
  'directory/requestWithdrawal',
  async (data, { rejectWithValue }) => {
    const url = baseUrl + 'withdrawalRequest';
    try {
      const response = await axios.post(url, data);
      if (response.data.status === 'success') {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      console.error("API Error:", err);
      return rejectWithValue(
        err.response?.data || { message: 'An error occurred during the withdrawal request' }
      );
    }
  }
);